export const NOT_IN_MAINTENANCE = {
    enabled: false,
    message: '',
    until: null,
    startsAt: null,
};
export const MAINTENANCE_CDN = 'https://d3ty207jh9oupr.cloudfront.net';
/** Flag URL for the session's environment (the email prefix decides it, P5). */
export function maintenanceUrlFor(environment, localOverride) {
    if (environment === 'test' || environment === 'prod') {
        return `${MAINTENANCE_CDN}/maintenance/${environment}.json`;
    }
    return localOverride?.trim() || null;
}
const str = (v) => (typeof v === 'string' ? v.trim() : '');
export function parseMaintenance(raw) {
    if (!raw || typeof raw !== 'object') {
        return NOT_IN_MAINTENANCE;
    }
    const o = raw;
    return {
        enabled: o.enabled === true,
        message: str(o.message),
        until: str(o.until) || null,
        startsAt: str(o.startsAt) || null,
    };
}
/** True for the API's 503 maintenance reply (`{maintenance: true, ...}`). */
export function isMaintenanceError(error) {
    if (!error || typeof error !== 'object') {
        return false;
    }
    const e = error;
    if (e.status !== 503 || !e.data || typeof e.data !== 'object') {
        return false;
    }
    return e.data.maintenance === true;
}
/** A non-GET, non-auth request (auth routes stay open during maintenance). */
export function isSuccessfulWrite(args) {
    if (typeof args === 'string') {
        return false;
    }
    const method = (args.method ?? 'GET').toUpperCase();
    return (method !== 'GET' &&
        method !== 'HEAD' &&
        !(args.url ?? '').includes('/auth/'));
}
/** Failures that are worth re-checking the flag for (network or 5xx). */
export function shouldRecheckAfter(error) {
    if (!error || typeof error !== 'object') {
        return false;
    }
    const status = error.status;
    if (status === 'FETCH_ERROR' || status === 'TIMEOUT_ERROR') {
        return true;
    }
    return typeof status === 'number' && status >= 500;
}
export function maintenanceFromError(error) {
    const data = error?.data;
    const info = parseMaintenance(data);
    return { ...info, enabled: true };
}
export const DEFAULT_MAINTENANCE_MESSAGE = "We're making some improvements. Your data is safe — we'll be back shortly.";
/** "Back around 10:00 AM" in the device's time zone, or null. */
export function formatEta(until, now = new Date(), locale = 'en-US') {
    if (!until) {
        return null;
    }
    const t = new Date(until);
    if (Number.isNaN(t.getTime())) {
        return null;
    }
    if (t.getTime() <= now.getTime()) {
        return 'Taking a little longer than expected';
    }
    const sameDay = t.toDateString() === now.toDateString();
    const time = new Intl.DateTimeFormat(locale, {
        hour: 'numeric',
        minute: '2-digit',
    }).format(t);
    if (sameDay) {
        return `Back around ${time}`;
    }
    const day = new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(t);
    return `Back around ${day} ${time}`;
}
